<template>
  <div class="travel-card"  @click="goTravelDetail(item.id)">
    <van-row class="card-container" >
      <!-- width="145" height="97" -->
      <van-image class="card-img" fit="fill"  @click="goTravelDetail(item.id)" :src="processImgs(item.imgs)" />
      <div class="travel-info">
        <van-row type="flex" justify="space-between" align="center">
          <van-col class="travel-title-text" @click="goTravelDetail(item.id)">{{item.name}}</van-col>
          <van-col class="travel-days" v-if="playDays">
            <div>{{playDays ? `${playDays}日游` :"" }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-between" align="center" class="publish-info">
          <van-col>发表时间：{{updateTime? processTime(updateTime): '-'}}</van-col>
        </van-row>
        <van-row type="flex"  class="publish-info-user">
          <van-col>用户：{{nickName ? nickName : `用户${item.userId}`}}</van-col>
        </van-row>
        <!-- <van-row class="like-comment" type="flex">
           <van-col class="like-common-col"><common-icon :iconId="'#iconzan'"></common-icon><span>1566</span></van-col>
           <van-col class="like-common-col"><common-icon :iconId="'#iconpingluntongzhi'"></common-icon><span>45</span></van-col>
        </van-row> -->
      </div>
    </van-row>
     <slot></slot>
  </div>
</template>
<script>
//使用vant的懒加载
import { Image as VanImage } from 'vant';
import { Button } from 'vant';
import { Search } from 'vant';
import { Col, Row,Tag } from 'vant';
import CommonIcon from "@/components/icon/CommonIcon"
export default {
  name: "travel-card",
  components: {
    CommonIcon,
    [Tag.name]:Tag,
    [Search.name] :Search,
    [Button.name] : Button,
    VanImage,
    [Col.name] :Col,
    [Row.name]:Row
  },
  props: {
    item: Object
  },
  data() {
    return {
      playDays: this.item.playDays,
      updateTime: this.item.updateTime,
      nickName: this.item.nickName
    };
  },
  watch: {
  },
  methods: {
    goTravelDetail(travelId) {
      this.$router.push({ path: `/travelDetail/${travelId}` }) 
    },
    processImgs(imgs) {
      if (imgs) {
        return imgs.split(";")[0];
      }
      return imgs;
    },
    processTime(value) {
      return value.slice(0, 10);
    },
    handleClick1() {
      this.$router.push({ path: '/button' });
    }
  }
};
</script>
<style lang="less">
.travel-card {
  .card-container {
    display: flex;
    justify-content: space-between;
    padding:2px 0px 5px 5px ;
    .card-img {
      width: 145px;
      min-width: 145px;
      height: 97px;
      img {
        border-radius: 4px;
      }
    }
    .travel-info {
      width: 185px;
      flex-basis: 185px;
      margin-left: 14px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .travel-title-text {
        font-size: 14px;
        max-width: 140px;
        color: #222222;
        overflow: hidden; 
        text-overflow:ellipsis; 
        white-space: nowrap;
      }
      .travel-days { 
        box-sizing: border-box;
        padding: 3px 4px;
        border-radius: 2px;
        background-color: #52e5cb;
        color: #ffffff;
        font-size: 9px;
        text-align: right;
        display: flex;
        align-items: center;
        overflow: hidden; 
        text-overflow:ellipsis; 
        white-space: nowrap;
      }
      .publish-info {
        color: #999999;
        font-size: 12px;
      }
      .publish-info-user {
        color: #999999;
        font-size: 12px;
        overflow: hidden; 
        text-overflow:ellipsis; 
        white-space: nowrap;
        max-width: 180px;
      }
      .like-comment {
        .like-common-col {
          font-size: 10px;
          display: flex;
          align-items: center;
          span {
            margin-left: 10px;
          }
        }
        .icon {
          font-size: 20px;
        }
      }
      //评论距离点赞一定距离
      .like-common-col:last-child {
        margin-left: 20px;
      }
    }
  }
}
</style>
